import apiService from '../apiService';

const tagsService = {

  async createTag(payload) {
    try {
      const response = await apiService.post(`/settings/tags`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getAllTags(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const response = await apiService.get(`/settings/tags${queryParams ? `?${queryParams}` : ''}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async getSingleTag(id) {
    try {
      const response = await apiService.get(`/settings/tags/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async updateTag(payload, id) {
    try {
      const response = await apiService.put(`/settings/tags/${id}`, payload);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

  async deleteTag(id) {
    try {
      const response = await apiService.delete(`/settings/tags/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
};

export default tagsService;